import {forwardRef} from 'react';

import Checkbox from '@mui/material/Checkbox';
import {styled} from '@mui/material/styles';

const CbIcon = styled('span')(({theme}) => ({
  'borderRadius': 4,
  'width': 16,
  'height': 16,
  'border': `1px solid ${theme.palette.common.swatch[50]}`,
}));

const CbCheckedIcon = styled(CbIcon)(({theme}) => ({
  'backgroundColor': theme.palette.primary.swatch[60],
  'border': `1px solid ${theme.palette.primary.swatch[60]}`,
  // 'backgroundImage': 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
  '&:before': {
    display: 'block',
    width: 14,
    height: 14,
    backgroundImage:
    // eslint-disable-next-line max-len
      `url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E")`,
    content: '""',
  },
}));

const zmCheckboxBaseStyle = ({checked, theme}) => `
&.MuiCheckbox-root {
  font-size: 16px;
  padding: 8px;
}
&:hover {
  .icon {
    border: 1px solid ${theme.palette.common.swatch[60]};
  }
  .checked-icon {
    border: 1px solid ${theme.palette.primary.swatch[70]};
    background-color: ${theme.palette.primary.swatch[70]};
  }
}
&.Mui-focusVisible {
  outline-color: #0E72ED;
  outline-style: auto;
  outline-width: 1px;
  border-radius: 4px;
}
`;

/**
 * @type {Checkbox}
 */
const ForwardRefCheckbox = forwardRef(
  ({...props}, ref) => {
    return (<Checkbox
      disableRipple
      {...props}
      icon={<CbIcon className="icon" />}
      checkedIcon={<CbCheckedIcon className="checked-icon"/>}
      size="small"
      ref={ref}
    >
    </Checkbox>);
  },
);

/**
 *
 * @param {*} props
 * @return {JSX.Element}
 */
export const ZmCheckbox = styled(ForwardRefCheckbox, {shouldForwardProp: () => true})(
  (props) =>
    `
    ${zmCheckboxBaseStyle(props)}
    `);
